// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Provides methods to encode binary data in base 64.
 * 
 * The built-int functions (atob and btoa) have not been used because:
 *  - they expect binary strings
 *  - they are not fast enough for our purposes
 */
export class Base64
{
  static encode(input: Uint8Array): string
  {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    const sixBitMask = 0b00111111;
    let encoded = [];
    let inputPosition = 0;

    while (inputPosition < input.length)
    {
      const byte0 = input[inputPosition];
      inputPosition++;
      const byte1 = inputPosition >= input.length ? null : input[inputPosition];
      inputPosition++;
      const byte2 = inputPosition >= input.length ? null : input[inputPosition];
      inputPosition++;

      const threeByteSequence = (byte0 << 16) + ((byte1 || 0) << 8) + (byte2 || 0);

      const encodedChar0 = (threeByteSequence >>> 18) & sixBitMask;
      const encodedChar1 = (threeByteSequence >>> 12) & sixBitMask;
      const encodedChar2 = byte1 == null ? 64 : (threeByteSequence >>> 6) & sixBitMask;
      const encodedChar3 = byte2 == null ? 64 : (threeByteSequence) & sixBitMask;

      encoded[encoded.length] = chars.charAt(encodedChar0);
      encoded[encoded.length] = chars.charAt(encodedChar1);
      encoded[encoded.length] = chars.charAt(encodedChar2);
      encoded[encoded.length] = chars.charAt(encodedChar3);
    }

    return encoded.join("");
  }
}